module.exports = __webpack_public_path__ + "static/media/download_bold-black.198ad66a.svg";